import type { TimePickerOption } from '../components/TimePicker';
import { OwaDate, differenceInMinutes } from 'owa-datetime';

export const getClosestTime = (
    options: TimePickerOption[],
    selectedTime: OwaDate
): TimePickerOption | null => {
    let min = Number.MAX_VALUE;
    let closestTime = null;
    options.forEach(option => {
        const diff = differenceInMinutes(selectedTime, option.date);
        if (diff >= 0 && diff < min) {
            min = diff;
            closestTime = option;
        }
    });
    return closestTime;
};
